export enum EntitiesTypes {
  BRAND = "brand",
  ORGANISATION = "organisation"
}
